import { GlobalAxios } from "../axios/axios-config";

const PATIENT_ENCOUNTER_PS_TRANSFER_REQUEST_REPROCESS_ROUTE =
  process.env.REACT_APP_EXTERNAL + "/api/v1/PatientEncounterPsTransferRequest/Reprocess";

export const reprocessPatientEncounterPsTransferRequests = ({
  ids,
}: {
  ids: string[];
}) => {
  return GlobalAxios.post(PATIENT_ENCOUNTER_PS_TRANSFER_REQUEST_REPROCESS_ROUTE, {
    ids,
  });
};
